import React from 'react'
import {
    List,
    Datagrid,
    ReferenceField,
    TextField
} from 'react-admin'

import { PermisoField } from '../Permiso'

export const PermisoList = props => (
    <List {...props} exporter={false} >
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <ReferenceField source="user" reference="usuarios">
                <TextField source="username" />
            </ReferenceField>
            <ReferenceField source="empresa" reference="empresas">
                <TextField source="name" />
            </ReferenceField>
            <ReferenceField source="encargado" reference="usuarios" allowEmpty>
                <TextField source="username" />
            </ReferenceField>
            <PermisoField source="permissions" label="Permisos"/>
        </Datagrid>
    </List>
);
